exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".districtOrgList table{margin-left:10%;width:80%}.districtOrgList tr{border-top:1px solid #ddd}.districtOrgList td{padding:1rem;vertical-align:top}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/appdev/wizards/district_org_list.scss
// module id = 824
// module chunks = 0